import React from "react";
import { Layout, Typography } from "antd";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

export default function DoorKey() {
  return (
    <Layout
      style={{
        height: "100vh",
        background: "var(--theme-bg)"
      }}
    >
      {/* 顶部栏 */}
      <Header
        style={{
          height: 56,
          background: "var(--theme-card-bg)",
          borderBottom: "1px solid var(--theme-border)",
          padding: "0 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "var(--theme-header-shadow)"
        }}
      >
        <Title
          level={4}
          style={{
            margin: 0,
            color: "var(--theme-header-text)"
          }}
        >
          门之钥
        </Title>

        <Text
          style={{
            fontSize: 12,
            color: "var(--theme-secondary)",
            opacity: 0.85
          }}
        >
          Powered by Coze
        </Text>
      </Header>

      {/* 主内容区 */}
      <Content
        style={{
          flex: 1,
          overflow: "hidden",
          background: "var(--theme-bg)"
        }}
      >
        <iframe
          title="DoorKey Chat"
          src="https://www.coze.cn/store/agent/7596688468013924386?bot_id=true"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            background: "transparent"
          }}
          allow="clipboard-write; microphone"
        />
      </Content>
    </Layout>
  );
}
